'use client'

import { Spacer, Text } from '@vinted/web-ui'

import { useFeatureSwitch } from '@marketplace-web/feature-flags/feature-switches-data'
import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

import ResponsiveWrapper from '../ReponsiveWrapper'
import PaymentsSafetySection from '../PaymentsSafetySection'
import NonPaymentsSafetySection from '../NonPaymentsSafetySection'
import TrustSection from '../TrustSection'
import InfoSection from '../InfoSection'
import TransparencyReportSection from '../TransparencyReportSection'

type Props = {
  showPro: boolean
}

const Safety = ({ showPro }: Props) => {
  const translate = useTranslate('trust_and_safety')

  const isPaymentsEnabled = useFeatureSwitch('payments')

  return (
    <>
      <ResponsiveWrapper mobile={<Spacer size="x4-large" />} desktop={<Spacer size="x6-large" />} />
      <div className="page-container">
        <Text as="h1">
          <div className="safety_header-title">{translate('intro_title')}</div>
        </Text>
        <ResponsiveWrapper
          mobile={<Spacer size="x2-large" />}
          desktop={<Spacer size="x4-large" />}
        />
        <Text as="span">
          <div className="safety_header-body">{translate('intro_body')}</div>
        </Text>
        <ResponsiveWrapper
          mobile={<Spacer size="x2-large" />}
          desktop={<Spacer size="x4-large" />}
        />
        {isPaymentsEnabled ? (
          <PaymentsSafetySection showPro={showPro} />
        ) : (
          <NonPaymentsSafetySection />
        )}
        <ResponsiveWrapper
          mobile={<Spacer size="x2-large" />}
          desktop={<Spacer size="x4-large" />}
        />
        <section>
          <Text as="h2">
            <div className="safety_header-title">{translate('explanation_title')}</div>
          </Text>
          <ResponsiveWrapper
            mobile={<Spacer size="x2-large" />}
            desktop={<Spacer size="x4-large" />}
          />
          <TrustSection showPro={showPro} />
          <ResponsiveWrapper
            mobile={<Spacer size="x4-large" />}
            desktop={<Spacer size="x6-large" />}
          />
        </section>
        <section>
          <Text as="h2">
            <div className="safety_header-title">{translate('all_you_need_title')}</div>
          </Text>
          <ResponsiveWrapper
            mobile={<Spacer size="x2-large" />}
            desktop={<Spacer size="x4-large" />}
          />
          <InfoSection showPro={showPro} />
          <ResponsiveWrapper
            mobile={<Spacer size="x4-large" />}
            desktop={<Spacer size="x6-large" />}
          />
        </section>
        {showPro ? null : (
          <section>
            <TransparencyReportSection />
          </section>
        )}
      </div>
    </>
  )
}

export default Safety
